import { render, staticRenderFns } from "./HandoverView.vue?vue&type=template&id=bae1832a&scoped=true&"
import script from "./HandoverView.vue?vue&type=script&lang=ts&"
export * from "./HandoverView.vue?vue&type=script&lang=ts&"
import style0 from "./HandoverView.vue?vue&type=style&index=0&id=bae1832a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae1832a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSpacer})
